import { useMutation } from '@tanstack/react-query';

import type { TrainerFormData } from '@/types/api/mutations';
import type { MutationResponse } from '@/types/api/mutations/common';

import { HttpClient } from '@/network/HttpClient';

export const useTrainerFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: TrainerFormData;
    }) =>
      HttpClient.request<MutationResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
